import Animation from './Animation';
import './Corruption.css';

export default class Corruption extends Animation {

	constructor (master, entity) {

		super(master, 0);
		this.entity = entity;
		//this.loadAudio("heal");
	}

	run () {

		var el = document.querySelector("#game-entity-" + this.entity + " .game-entity-main .game-entity-img-wrapper");
		if (el) {
			el.classList.add("corruption-anim");
			setTimeout(() => el.classList.remove("corruption-anim"), 900);
		}
	}
}